import en from './locale/en';
import pt_BR from './locale/pt_BR';
import es from './locale/es';

export default {
  en,
  pt_BR,
  es,
};
